import { DateTime } from 'luxon';
import { regexOnlyNumber } from 'shell/constants/regex';
import * as yup from 'yup';

export const deathSchemaObject = {
  // matricola: yup.string().required('Campo obbligatorio'),
  deathPresumed: yup.boolean().notRequired(),
  deathMunicipality: yup.string().required('Campo obbligatorio'),
  yearDate: yup.string().matches(regexOnlyNumber, 'Campo numerico'),
  years: yup.string().matches(regexOnlyNumber, 'Campo numerico'),
  deathDate: yup.date().nullable().typeError('Data non valida'),
  hourDeathDate: yup.date().nullable().notRequired(),
  deathBy: yup.date().nullable().typeError('Data non valida'),
  deathTo: yup
    .date()
    .nullable()
    .typeError('Data non valida')
    .when('deathBy', (deathBy: Date) => {
      if (deathBy && DateTime.fromJSDate(deathBy).isValid) {
        return yup
          .date()
          .nullable()
          .typeError('Data non valida')
          .min(
            DateTime.fromJSDate(deathBy).plus({ day: 1 }),
            'La data deve essere successivo alla data Morto tra'
          );
      }
      return yup.date().nullable().typeError('Data non valida');
    }),
};

const createSchema = yup.object(deathSchemaObject);

export default createSchema;
